import { Gameplay } from "appworks/model/gameplay/gameplay";
import { Record } from "appworks/model/gameplay/records/record";
import { RecordBuilder } from "appworks/server/builders/record-builder";
import { PartnerConnect } from "partner-connect/partner-connect-manager";
import { tgrHybridSpinRecordBuilder } from "./tgr-hybrid-spin-record-builder";

export class TGRRestoreRecordBuilder implements RecordBuilder {
    public id: string = "TGRPartnerConnectRestoreRecordBuilder";

    public filter(request: any, response: PartnerConnect.SpinResponse): boolean {
        return request.type === "restore";
    }

    public build(gameplay: Gameplay, request: any, response: PartnerConnect.SpinResponse): Record[] {
        const records: Record[] = [...tgrHybridSpinRecordBuilder.build(gameplay, request, response as PartnerConnect.SpinResponse)];
        gameplay.isRecovered = true;
        return records;
    }
}

export const tgrRestoreRecordBuilder = new TGRRestoreRecordBuilder();
